// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".other-nav .gm-v3-header-user__text{color:#fff;opacity:.9}.other-nav .gm-v3-header-user__text:hover{opacity:1}", ""]);
// Exports
module.exports = exports;
